import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-string-operator',
  templateUrl: './string.component.html',
  styleUrls: ['./string.component.css']
})
export class StringComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
